import React from "react"
import { useNavBarQuery } from "./NavBar.query"

import { NavBarView } from "./NavBar.view"

export function NavBarContainer({setOpen}) {
  const data = useNavBarQuery()
  return <NavBarView setOpen={setOpen} data={data.saleor.menu?.items} />
}
